import React from 'react'
import { css } from '@emotion/core'

type Props = {
  /** 0以下のときは何も描画しない */
  count: number
}

/** タブ見出しなどの横に並べる件数バッジ。件数は打ち止めにせずそのまま出す */
export const CountBadge: React.FC<Props> = ({ count }) => {
  if (count <= 0) {
    return null
  }
  return <span css={badgeStyle}>{count}</span>
}

const badgeStyle = css({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 20,
  height: 20,
  padding: '0 6px',
  borderRadius: 10,
  background: '#F2A40B',
  color: '#FFFFFF',
  fontSize: 12,
  fontWeight: 'bold',
  lineHeight: 1,
})
